import { render, staticRenderFns } from "./Sex.vue?vue&type=template&id=d3c23458&"
import script from "./Sex.vue?vue&type=script&lang=js&"
export * from "./Sex.vue?vue&type=script&lang=js&"
import style0 from "./Sex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports